import CustomAppBar from "./components/CustomAppBar";
import { Layout } from "react-admin";
import React from "react";
import { Admin, Resource, CustomRoutes, fetchUtils } from "react-admin";
import jsonServerProvider from "ra-data-json-server";
import ListUnsuccessfulPayments from "./pages/ListUnsuccessfulPayments";
import Dashboard from "./pages/Dashboard";
import WalletPoints from "./pages/WalletPoints";
import { Route } from "react-router-dom";
import ListUsers, { UserShow } from "./pages/ListUsers";
import { SevaList, SevaAdmin } from "./pages/ListSevas";
import ListBirthdays, { BirthdaysShow } from "./pages/ListBirthdays";
import ListPujaPaymentsShow, { PujaPaymentsShow } from "./pages/PujaPaymentsScreen";
import ListWebviews, { CreateWebview, EditWebview } from "./pages/ListWebviews";
import ListCompletedPledge from "./pages/ListCompletedPledge";
import ListOngoingPledge from "./pages/ListOngoingPledge";
import ListFlagDates from "./pages/ListFlagDates";
import NarasimhaYagyaData from "./pages/NarasimhaYagyaData";
import ListPayments, { EditPayment } from "./pages/ListPayments";
import ListReceipts from "./pages/ListReceipts";
import ListOverdues from "./pages/ListOverdues";
import ListCompletedPujas from "./pages/ListComPujas";
import ListUpcomingPujas from "./pages/ListUpPujas";
import ListHomepageCarousel from "./pages/HomepageCarousel";
import ListMessages from "./pages/ListMessages";
import CronMessages from "./pages/CronMessages";
import SmsEmailErrors from "./pages/SmsEmailErrors";
import ListProducts, { ProductCreate, productEdit } from "./pages/ListProducts";
import TicketShow from "./pages/TicketShow";
import ListNotifications, {
  NotificationCreate,
  NotificationShow,
} from "./pages/ListNotifications";
import ListCampaigns, {
  CampaignCreate,
  campaignEdit,
} from "./pages/ListCampaigns";
import addUploadCapabilities from "./components/addUploadCapabilities";
import authProvider from "./components/authProvider";
// icons-material
import UsersIcon from "@mui/icons-material/Group";
import DoneAll from "@mui/icons-material/DoneAll";
import Schedule from "@mui/icons-material/Schedule";
import CronIcon from "@mui/icons-material/AvTimer";
import WarningIcon from "@mui/icons-material/Warning";
import FlagIcon from "@mui/icons-material/AssistantPhoto";
import ChatIcon from "@mui/icons-material/Chat";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LabelIcon from "@mui/icons-material/Label";
import InfoIcon from "@mui/icons-material/Info";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AssessmentIcon from "@mui/icons-material/Assessment";

import ListPledges from "./pages/ListPledges";


const CustomLayout = (props) => <Layout {...props} appBar={CustomAppBar} />;
const httpClient = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem("token");
  if (token) {
    options.headers.set("Authorization", token);
  }
  const response = await fetchUtils.fetchJson(url, options);

  // 👇 ONLY this block is new
  if (url.includes("/pledges") && response.json?.pledges) {
    return {
      ...response,
      json: response.json.pledges.map(item => ({
        ...item,
        id: item._id,
      })),
      headers: new Headers({
        "X-Total-Count": response.json.pledges.length,
      }),
    };
  }

  return response;
};

const App = () => {
  const API_BASE = `${(process.env.REACT_APP_BASE_URL || "").replace(/\/?$/, "/")}admin`;
  console.log("API_BASE =", API_BASE);

  // Create the dataProvider properly
  const dataProvider = jsonServerProvider(API_BASE, httpClient);
  const dataProviderWithUpload = addUploadCapabilities(dataProvider);

  return (
    <Admin layout={CustomLayout}
      authProvider={authProvider}
      dataProvider={dataProviderWithUpload}
    >
      <Resource
        options={{ label: "Dashboard" }}
        name="dashboard"
        list={Dashboard}
      />
      <Resource
        options={{ label: "Wallet Points" }}
        name="wallet-points"
        list={WalletPoints}
      />
      <Resource
        options={{ label: "Webviews" }}
        create={CreateWebview}
        name="webview"
        edit={EditWebview}
        list={ListWebviews}
      />
      <Resource
        options={{ label: "Homepage Carousel" }}
        // create={CreateWebview}
        name="homepagecarousel"
        // edit={EditWebview}
        list={ListHomepageCarousel}
      />
      <Resource
        icon={ReceiptIcon}
        name="payments"
        options={{ label: "Donations App" }}
        edit={EditPayment}
        list={ListPayments}
      />
      <Resource
        icon={ReceiptIcon}
        name="payments-td"
        options={{ label: "Donations TD" }}
        edit={EditPayment}
        list={ListPayments}
      />
      <Resource
        icon={ReceiptIcon}
        name="receipts"
        options={{ label: "Donation Receipt" }}
        list={ListReceipts}
      />
      <Resource
        icon={ReceiptIcon}
        name="completedpledge"
        options={{ label: "Completed Pledge" }}
        list={ListCompletedPledge}
      />
      <Resource
        icon={ReceiptIcon}
        name="ongoingpledge"
        options={{ label: "Ongoing Pledge" }}
        list={ListOngoingPledge}
      />
      <Resource icon={InfoIcon} name="overdues" list={ListOverdues} />
      <Resource
        icon={WarningIcon}
        options={{ label: "All donations" }}
        name="unsuccessfulpayments"
        list={ListUnsuccessfulPayments}
      />
      <Resource
        create={ProductCreate}
        icon={AssessmentIcon}
        name="products"
        edit={productEdit}
        list={ListProducts}
      />
      <Resource
        icon={LabelIcon}
        name="campaigns"
        create={CampaignCreate}
        edit={campaignEdit}
        list={ListCampaigns}
      />
      <Resource
        show={UserShow}
        icon={UsersIcon}
        name="users"
        list={ListUsers}
      />
      <Resource name="sevas" list={SevaAdmin} />

      <CustomRoutes>
        <Route path="/seva-admin" element={<SevaAdmin />} />
        <Route path="/wallet-points" element={<WalletPoints />} />
      </CustomRoutes>
      <Resource
        show={BirthdaysShow}
        icon={UsersIcon}
        name="Birthdays"
        list={ListBirthdays}
      />
      <Resource
        show={ListPujaPaymentsShow}
        icon={UsersIcon}
        options={{ label: "Puja Payments" }}
        name="pujaPayments"
        list={PujaPaymentsShow}
      />
      <Resource
        create={NotificationCreate}
        show={NotificationShow}
        icon={NotificationsIcon}
        name="notifications"
        list={ListNotifications}
      />
      <Resource
        options={{ label: "Overdue Mails" }}
        icon={CronIcon}
        name="overduedata"
        list={CronMessages}
      />
      <Resource
        options={{ label: "Notification Mails" }}
        icon={CronIcon}
        name="notificationdata"
        list={CronMessages}
      />
      <Resource
        options={{ label: "Completed Pujas" }}
        icon={DoneAll}
        name="completedpujas"
        list={ListCompletedPujas}
      />
      <Resource
        options={{ label: "Upcoming Pujas" }}
        icon={Schedule}
        name="upcomingpujas"
        list={ListUpcomingPujas}
      />
      <Resource
        show={UserShow}
        icon={FlagIcon}
        options={{ label: "Special dates" }}
        name="specialdates"
        list={ListFlagDates}
      />
      <Resource
        icon={ChatIcon}
        name="pledges"
        list={ListPledges}
        options={{ label: "New Pledge Request" }}
      />
      <Resource
        icon={ChatIcon}
        name="messages"
        list={ListMessages}
        show={TicketShow}
        options={{ label: "Manage support tickets" }}
      />
      <Resource
        icon={ChatIcon}
        options={{ label: "Narasimha Yagya Data" }}
        name="yagya"
        list={NarasimhaYagyaData}
      />
      <Resource
        icon={ChatIcon}
        options={{ label: "Sms And Email Errors" }}
        name="smsemailerrors"
        list={SmsEmailErrors}
      />
    </Admin>
  );
};

export default App;
